import AppDownload from './AppDownload';

export { default as AppDownloadTheme } from './AppDownload.styled';
export default AppDownload;
